import { InlineEmptyStateOnboarding, formatExternalUrl } from "@octopusdeploy/design-system-components";
import { useQuery } from "@octopusdeploy/octopus-react-client";
import type { ApprovalResource } from "@octopusdeploy/octopus-server-client";
import { useState } from "react";
import { ApprovalsInner } from "~/areas/tasks/components/Task/Approvals/ApprovalsInner";
import { session } from "~/clientInstance";
interface ApprovalsProps {
    spaceId: string;
    serverTaskId: string;
    serverTaskState: string | undefined;
}
export const Approvals = ({ spaceId, serverTaskId, serverTaskState }: ApprovalsProps) => {
    const [currentUsersApproval, setCurrentUsersApproval] = useState<ApprovalResource | null>(null);
    const { result } = useQuery(async (repository) => {
        return {
            teamMemberships: session.currentUser ? await repository.TeamMembership.getForUser(session.currentUser, true) : [],
            usersLookup: await repository.Users.all(),
        };
    }, [], "Get users team memberships and users lookup");
    const teamMembershipIds = result?.teamMemberships?.map((t) => t.TeamId);
    const { result: approvalPolicy, refetch } = useQuery(async (repository) => {
        return await repository.ApprovalPolicies.getByServerTask(serverTaskId);
    }, [serverTaskId], "Get approval policy and approvals for server task");
    const approvalPolicyResponse = approvalPolicy?.Resource;
    if (!approvalPolicyResponse)
        return <InlineEmptyStateOnboarding illustration={"EmptyState"} entityName={"Approvals"} learnMore={{ path: formatExternalUrl("/"), label: "Docs: Octopus Approvals" }}/>;
    return <ApprovalsInner approvalPolicyResponse={approvalPolicyResponse} teamMembershipIds={teamMembershipIds ?? []} serverTaskState={serverTaskState} refetch={refetch} users={result?.usersLookup}/>;
};
